import axios from 'axios/dist/axios';

export default class AxiosService {
    /* @ngInject */
    constructor() {
        this.baseURL = 'https://2vwwhov5gc.execute-api.eu-west-1.amazonaws.com';
        this.hostname = 'scanbox.cc.telenorconnexion.com';
        this.account = '080159586263';
        this.env = 'prod';
        this.apikey = '14mDeoVpjx6DZqaPpGx3q2LbX0gmJUhs5htQRv2A';

        this.http = axios.create({
            baseURL: `${this.baseURL}/${this.env}`,
            params: {
                hostname: this.hostname,
                account: this.account,
                env: this.env,
            },
            headers: {
                'x-api-key': this.apikey,

            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/axios.service.js